// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"117":"bbfa247e00bd2a0a","708":"87b59e03803a044b"}[chunkId] + ".js";
};